"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpIFrame = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const iframe_html_1 = __importDefault(require("./iframe.html"));
let ItpIFrame = class ItpIFrame extends vue_1.default {
    $refs;
    id;
    html;
    onHTMLChanged() {
        this.$refs.iframe.srcdoc = this.html ? this.html : '';
    }
};
exports.ItpIFrame = ItpIFrame;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIFrame.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIFrame.prototype, "html", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('html'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpIFrame.prototype, "onHTMLChanged", null);
exports.ItpIFrame = ItpIFrame = __decorate([
    (0, vue_property_decorator_1.Component)({ template: iframe_html_1.default })
], ItpIFrame);
//# sourceMappingURL=iframe.js.map